/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ApiEstimationPermission,
  EstimationUserAssignmentRequest,
  EstimationUserAssignmentResponse,
  V1EstimationsPermissionsListError,
  V1EstimationsUsersUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationUserAssignment<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags EstimationUserAssignment
   * @name V1EstimationsUsersUpdate
   * @request PUT:/api/v1/estimations/{estimationId}/users
   * @secure
   * @response `200` `(EstimationUserAssignmentResponse)[]` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsUsersUpdate = (
    estimationId: string,
    data: EstimationUserAssignmentRequest[],
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationUserAssignmentResponse[], V1EstimationsUsersUpdateError>({
      path: `/api/v1/estimations/${estimationId}/users`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationUserAssignment
   * @name V1EstimationsPermissionsList
   * @request GET:/api/v1/estimations/{estimationId}/permissions
   * @secure
   * @response `200` `(ApiEstimationPermission)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsPermissionsList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<ApiEstimationPermission[], V1EstimationsPermissionsListError>({
      path: `/api/v1/estimations/${estimationId}/permissions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
